import { render, staticRenderFns } from "./SiteNotificationIndex.vue?vue&type=template&id=487e2d05&scoped=true&"
import script from "./SiteNotificationIndex.vue?vue&type=script&lang=js&"
export * from "./SiteNotificationIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487e2d05",
  null
  
)

export default component.exports